import { localStorageService } from './local-storage-service';

export const clientIdService = localStorageService('client_id');
